export default __webpack_public_path__ + "3226b7c708dc0e932ab6dc5872eee679.svg";